import React from 'react';
import GeneralContactForm from './GeneralContactForm';
import fountain from '../images/fountain.jpg';
import hug from '../images/hug.jpg';
import main from '../images/main1.jpg';
import Helmet from "react-helmet";

const Sell = () => (
  <div className="full-job-ctn">
    <Helmet>
      <title>Hamilton Homes - Sell with Us</title>
      <meta name="description" content="We simplify your selling processes, and with our expertise, make sure you get what you want for the price you ask!"/>
      <meta name="keywords" content="selling,hamilton,homes,for,sale,niburski,search,condos,luxury,business"/>

      <meta property="og:url" content="https://besthamiltonhouses.com/buy"/>
      <meta property="og:title" content="Hamilton Homes - Sell"/>
      <meta property="og:description" content="We simplify your selling processes, and with our expertise, make sure you get what you want for the price you ask!"/>
    </Helmet>

    <div className="job-outline">
      <div className="full-job-details-stacked listing-page buy-page">
        <div className="heading">
          <h2>Selling With Us</h2>
        </div>

        <div className="split">
          <div className="left">
            <div className="steps">
              <div className="step">
                <h3>Expertise Unlike no Other</h3>
                <p>
                  We will work for you every step of the way! Our combination of skill, experience, and technology ensures that we can sell your home for the highest possible price and in the shortest period of time. We have the tools to meet the demands of a highly competitive, modern market.
                </p>
              </div>

              <div className="step">
                <h3>Our Unique Automated Internet Marketing System Online Presence: Available 24 hours a day!</h3>
                <p>
                  Our online marketing system allows us to make information accessible 24-hours a day, and to respond immediately and directly to each and every prospective buyer. From our website, prospective buyers can get information immediately about your home. They can access our site 24 hours a day and view your property listing! Through our Personal Home Search, your listing will be sent by e-mail to every prospective buyer in our database, where your home meets their criteria. Plus it will be e-mailed automatically to future prospective buyers as well.
                </p>
              </div>

              <div className="step">
                <h3>Traditional Marketing</h3>
                <p>
                  As soon as you list your home with me, we will enter your home in the Multiple Listing Service (MLS) database. Other agents can immediately access your property information by computer. Plus, your property will be included in any printed MLS books. we also regularly publish in magazines and newspapers in the area and send out direct mail pieces to potential buyers
                </p>
              </div>

              <div className="step">
                <h3>Pricing Your Home</h3>
                <p>
                  When you think about it, there are several other homes for sale competing with your home. we will help you price your home competitively to attract qualified buyers. The way we do this is by generating a Comparative Market Analysis (CMA) report, which will show you a range of prices being paid for homes in your area. You can complete our online form to get a feel for your home's market value.
                </p>
              </div>

              <div className="step">
                <h3>Every Step Of The Way</h3>
                <p>
                  Remember, we will be working for you every step of the way to make sure that you get the highest possible price for your home in the shortest period of time.
                </p>
              </div>
            </div>
          </div>

          <div className="right">
            <GeneralContactForm />

            <img src={main} />
          </div>
        </div>

        <br/>
        <br/>
        <br/>
      </div>
    </div>
  </div>
);

export default Sell;
